export const formatWhatsAppNumber = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber) return null;

  // 1️⃣ Remove everything except digits
  let code = countryCode.toString().replace(/\D/g, '');
  let number = phoneNumber.toString().replace(/\D/g, '');

  // 2️⃣ Remove leading 00 (international format)
  if (number.startsWith('00')) {
    number = number.substring(2);
  }

  // 3️⃣ Remove country code if user already typed it
  if (number.startsWith(code)) {
    number = number.substring(code.length);
  }

  // 4️⃣ Remove leading zero (local format like 03xxxx)
  if (number.startsWith('0')) {
    number = number.substring(1);
  }

  // 5️⃣ Final WhatsApp number
  const finalNumber = `${code}${number}`;

  return `https://wa.me/${finalNumber}`;
};
